import axios from "axios";
import appConfig from "@/config";
import { getCookie } from '@/utils/auth/authService';
const BASE_URL = appConfig.api.base;
const STAGING_URL = appConfig.api.staging;

export function getUser(
    sentUrl = false,
    auth = getCookie("token")
) {
    let url = "";
    if (window.localStorage.getItem("staging") === "true")
        url = `${STAGING_URL}/users/me`;
    else if (sentUrl !== false) url = `${sentUrl}/users/me`;
    else url = `${BASE_URL}/users/me`;
    let token = auth;
    return axios({
        method: "get",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token
        }
    });
}

export function linkUserToUser(baseEmail, targetEmail) {
    const url = `${BASE_URL}/users/me`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");

    return axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        },
        data: {
            baseEmail,
            targetEmail
        }
    });
}

export function assignDevice(targetMerchantId, parentId) {
    const url = `${BASE_URL}/pos/merchants/register`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");

    return axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        },
        data: {
            targetMerchantId,
            parentId
        }
    });
}

export function getSingleUser(id, loadAccount = false, reveal = null) {
    const url = `${BASE_URL}/users/${id}`;
    let token = getCookie("token");
    return axios({
        method: "get",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token
        },
        params: {
            loadAccount,
            reveal
        }
    });
}

export function refreshMerchantKeys(
    username,
    freshRequest = false,
    otp = false
) {
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    const url = `${BASE_URL}/users/keys`;
    return axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        },
        data: {
            username: username,
            freshRequest: freshRequest,
            otp: otp
        }
    });
}

export function changeUserPassword(email, oldPassword, newPassword) {
    const url = `${BASE_URL}/users/me`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    return axios({
        method: "put",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        },
        data: {
            email: email,
            oldPassword: oldPassword,
            newPassword: newPassword
        }
    });
}

export function updateMerchantScope(currentScopeMerchantId, email) {
    const url = `${BASE_URL}/users/merchant/scope`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    return axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        },
        data: {
            current_scope_merchant_id: currentScopeMerchantId,
            email
        }
    });
}

export function getTeam() {
    const url = `${BASE_URL}/team/users`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    return axios({
        method: "get",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        }
    });
}

export function getPreferences() {
    const url = `${BASE_URL}/preferences`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    return axios({
        method: "get",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        }
    });
}

export function getConfig() {
    const url = `${BASE_URL}/config`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    return axios({
        method: "get",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        }
    });
}

export function updateConfig(sentId, sentValue, sentName) {
    const url = `${BASE_URL}/config`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    return axios({
        method: "put",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        },
        data: {
            id: sentId,
            value: sentValue,
            name: sentName,
            private: 1,
            type: null,
            type_value: null
        }
    });
}

export function getKeys() {
    const url = `${BASE_URL}/keys`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    return axios({
        method: "get",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        }
    });
}

export function saveUser(data) {
    const url = `${BASE_URL}/team/users`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    return axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        },
        data: {
            email: data.useremail,
            name: data.fullname,
            role: data.role,
            activeowner: data.activeowner ? 1 : 0
        }
    });
}

export function deleteUser(data) {
    const url = `${BASE_URL}/team/users`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    return axios({
        method: "delete",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        },
        data: {
            email: data
        }
    });
}

export function editUser(userId, role, activeowner) {
    const url = `${BASE_URL}/team/users/role/new`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    return axios({
        method: "put",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        },
        data: {
            userId,
            role,
            activeowner: activeowner ? 1 : 0
        }
    });
}



// WEBPACK FOOTER //
// ./src/utils/user/getUserDetails.js